import { useFormContext, useWatch } from 'react-hook-form';

import classNames from 'classnames/bind';
import { Image } from 'shared';
import Box from 'shared_DEPRECATED/components/Box/Box';
import { isImage } from 'shared_DEPRECATED/components/File/utils';
import { Flex } from 'shared_DEPRECATED/components/Flex';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import { Video } from 'shared_DEPRECATED/components/Video/Video';

import { CHAT_FORM_FIELD_NAMES } from 'features/chat/config';
import { UnuploadedAttachment } from 'features/chat/config/types/Attachment';

import { ButtonIcon } from 'shared/components/Button';

import styles from 'features/chat/components/Chat.module.css';

const cx = classNames.bind(styles);

export const ChatMediaFilesPreview = () => {
  const methods = useFormContext();

  const files = useWatch({
    control: methods.control,
    name: CHAT_FORM_FIELD_NAMES.FILES,
  }) as UnuploadedAttachment[];

  return (
    <Flex flexWrap="wrap" gap="var(--spacing02)">
      {files.map(({ file }, index) => {
        const mediaUrl = URL.createObjectURL(file);

        return (
          <Box
            key={index}
            style={{
              position: 'relative',
              ...(files.length > 1 && {
                flexBasis: 'calc(50% - var(--spacing01))',
                aspectRatio: '1/1',
              }),
            }}
          >
            {isImage(file.type) ? (
              <Image
                src={mediaUrl}
                alt={file.name}
                width="100%"
                overflow="hidden"
                display="block"
                objectFit="cover"
                contentType={file.type}
                // @ts-ignore
                borderRadius={5}
                data-testid="chat-image-preview"
              />
            ) : (
              <Video
                src={mediaUrl}
                className={cx('media-preview')}
                data-testid="chat-video-preview"
              />
            )}
            {files.length > 1 && (
              <ButtonIcon
                aria-label="remove file"
                onClick={() =>
                  methods.setValue(
                    CHAT_FORM_FIELD_NAMES.FILES,
                    files.filter((_, i) => i !== index)
                  )
                }
                bgColor="rgba(0, 0, 0, 0.5)"
                position="absolute"
                bottom="10px"
                right="10px"
              >
                <Icon
                  name={iconNames.binFilled}
                  width="20px"
                  height="20px"
                  fill="white"
                />
              </ButtonIcon>
            )}
          </Box>
        );
      })}
    </Flex>
  );
};
